import { Button } from '@auctisync/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

type SignOutButtonProps = {
  /**
   * Where to send the user after signing out. Defaults to the admin sign-in.
   */
  redirectTo?: string;
};

/**
 * Clears the Supabase session and navigates home. Small for now — a
 * production account menu with "Switch tenant", "Settings", etc. lands with
 * the admin shell module.
 */
export function SignOutButton({ redirectTo = '/admin' }: SignOutButtonProps) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  async function handleSignOut() {
    setBusy(true);
    await supabase.auth.signOut();
    await navigate(redirectTo, { replace: true });
  }

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={busy}
      onClick={() => {
        void handleSignOut();
      }}
    >
      {busy ? 'Signing out…' : 'Sign out'}
    </Button>
  );
}
